<template>
  <div class="carousel-box">
    <div
      ref="carousel"
      class="kausid-carousel owl-theme owl-carousel"
    >
      <div class="slide-item" v-for="(slide, index) in slides" :key="index">
        <div class="row clearfix">
          <!-- Text Column -->
          <div class="text-column col-lg-5 col-md-12 col-sm-12">
            <div class="inner">
              <ul class="info-list">
                <li class="clearfix">
                  <strong>Name:</strong>
                  <span>{{ slide.name }}</span>
                </li>
                <li class="clearfix">
                  <strong>Localité:</strong>
                  <span>{{ slide.location }}</span>
                </li>
              </ul>
              <div class="video-link">
                <a :href="slide.videoUrl" class="lightbox-image" target="_blank">
                  <span class="link-text">watch his story</span>
                </a>
              </div>
            </div>
          </div>

          <!-- Image Column -->
          <div class="image-column col-lg-7 col-md-12 col-sm-12">
            <div class="image" style="position: relative;">
              <a
                :href="slide.videoUrl"
                class="lightbox-image"
                data-fancybox="gallery"
                target="_blank"
              >
                <img
                  :src="`https://img.youtube.com/vi/${slide.videoId}/maxresdefault.jpg`"
                  alt="YouTube thumbnail"
                  style="width: 100%; height: auto;"
                />
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/YouTube_icon_%282013-2017%29.png/600px-YouTube_icon_%282013-2017%29.png"
                  alt="YouTube Logo"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 90px; height: 90px;"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCarousel',
  data() {
    return {
      slides: [
        {
          name: 'Prière de vendredi dans une mosquée',
          location: 'Akébou Région des plateaux',
          videoUrl: 'https://www.youtube.com/watch?v=TMXUZ_qR0Ug',
          videoId: 'TMXUZ_qR0Ug',
        },
        {
          name: 'La joie de la population en particulier les enfants lors de l’inauguration du forage',
          location: 'Akébou Région des plateaux',
          videoUrl: 'https://youtu.be/8u-L-JeSEjA',
          videoId: '8u-L-JeSEjA',
        },
        {
          name: 'Taliq en arabe',
          location: 'Akébou Région des plateaux',
          videoUrl: 'https://youtu.be/9Hp9gQkXIXw',
          videoId: '9Hp9gQkXIXw',
        },
        {
          name: 'Taliq lors de l’inauguration du forage',
          location: 'Akébou Région des plateaux',
          videoUrl: 'https://youtu.be/JFgCg8M8beI',
          videoId: 'JFgCg8M8beI',
        },
        {
          name: "Converti en islam lors de l'inauguration de la mosquée",
          location: 'Akébou Région des plateaux',
          videoUrl: 'https://youtu.be/_e5t-YKQmjg',
          videoId: '_e5t-YKQmjg',
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      $(this.$refs.carousel).owlCarousel({
        loop: true,
        margin: 10,
        autoHeight: true,
        lazyLoad: true,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 6000,
        smartSpeed: 300,
        // navText: [
        //   '<span class="owl-prev"></span>',
        //   '<span class="owl-next"></span>',
        // ],
        responsive: {
          0: { items: 1 },
          768: { items: 1 },
          1000: { items: 1 },
        },
      });
    });
  },
};
</script>

<style scoped>
.owl-nav {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 5;
}
.owl-nav .owl-prev,
.owl-nav .owl-next {
  pointer-events: all;
  font-size: 2rem;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
</style>
